import axios from "axios";
import base_url from "./Constants";
import location_url from "./Constants"

// axios.defaults.withCredentials = true;
const request = axios.create({
  baseURL: base_url,
  // baseURL: 'http://127.0.0.1:8088',
})
export default request





// WEBPACK FOOTER //
// ./src/utils/axiosUtils.js